import type { LanguagePack } from "./languagePack";

import "./Supporters.css";

interface SupporterProps {
  supporter: {
    url: string;
    logo: string;
    name: string;
  };
}

const Supporter = ({ supporter }: SupporterProps) => (
  <li>
    <a href={supporter.url} target="_blank" rel="noreferrer">
      <img src={supporter.logo} alt={supporter.name} />
    </a>
  </li>
);

interface SupportersProps {
  languagePack: LanguagePack;
}

const Supporters = ({ languagePack }: SupportersProps) => {
  const supporterRows = [
    languagePack.supporters.slice(0, 3),
    languagePack.supporters.slice(3, 6),
    languagePack.supporters.slice(6, 9),
  ];

  return (
    <section className="section-wrapper">
      <h2>{languagePack.supportersHeading}</h2>
      <nav className="supporters">
        {supporterRows.map((supporterRow, supporterRowIndex) => (
          <ul key={supporterRowIndex}>
            {supporterRow.map((supporter) => (
              <Supporter key={supporter.name} supporter={supporter} />
            ))}
          </ul>
        ))}
      </nav>
    </section>
  );
};

export default Supporters;
